import React from 'react';

import * as Conditions from './conditions';

import { SPAM_MODERATION_ORGANIZATION_ID } from '../../../../../../constants/moderation';

const CONDITIONS = [
    { type: 'delay', event: false, component: Conditions.DelayCondition },
    { type: 'form-input', event: false, component: Conditions.FormInputCondition },
    { type: 'form-select', event: false, component: Conditions.FormInputCondition },
    { type: 'date-range', event: false, component: Conditions.DateRangeCondition },
    { type: 'rate-filter', event: false, component: Conditions.RateFilterCondition },
    { type: 'order-valid', event: false, component: Conditions.OrderValidCondition },
    { type: 'attendee-removed', event: false, component: Conditions.AttendeeRemovedCondition },
    { type: 'spam-score', event: true, component: Conditions.SpamScoreCondition }
    // { type: 'mail-not-delivered', event: false, component: Conditions.MailNotDeliveredCondition},
];

export class TransitionConditionHandler {
    #condition;
    #conditions;
    #component;

    constructor(condition) {
        this.#condition = condition;
        this.#conditions = CONDITIONS;
        this.#component = this.#conditions.find(act => act.type === this.#condition.type);
    }

    validate() {
        if (!this.#component) {
            throw new Error(`${this.#condition} is not valid, please provide a valid condition`);
        }
    }

    get component() {
        this.validate();
        return this.#component.component;
    }

    static get_allowed_conditions = organizationId => {
        const is_event_spam = organizationId === SPAM_MODERATION_ORGANIZATION_ID;
        return CONDITIONS.filter(ac => ac.event === is_event_spam).map(ac => ac.type);
    };
}

const TransitionConditionComponent = ({ organizationId, flowId, condition, handleCondition, handleConditionObject }) => {
    if (!condition || !condition.type) {
        return null;
    }
    const ConditionComponent = new TransitionConditionHandler(condition).component;
    return (
        <ConditionComponent organizationId={organizationId} flowId={flowId} condition={condition} handleCondition={handleCondition} handleConditionObject={handleConditionObject} />
    );
};

export default TransitionConditionComponent;
